import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  //transform(values: any[], args?: any): any {
  //  console.log(JSON.stringify(values));
  //  console.log(JSON.stringify(args));
  //  return values.filter((item => ))
  //}
  transform(items: Array<any>, filter: { [key: string]: any }): Array<any> {
    console.log(items);
    console.log(filter);

    //return null;


    return items.filter(item => {
      let notMatchingField = Object.keys(filter)
        .find(key => item[key] === filter[key]);
      console.log(notMatchingField);
      return notMatchingField; // true if matches all fields
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/Pipes/filter.pipe.ts